import axios from "axios";
import {
  EDIT_SUBSCRIPTIONS_FAIL,
  EDIT_SUBSCRIPTIONS_REQUEST,
  EDIT_SUBSCRIPTIONS_SUCCESS,
  GET_SUBSCHOICE,
  GET_SUBSCRIBER,
  GET_SUBSCRIPTION_CHECKBOX,
  TOGGLE_CHECKBOX
} from "../constants/subscription"

const SUBSCRIPTION_BASE_URL = `${process.env.REACT_APP_API_URL}/dashboard/apiv2`;

export const fetchSubscribers = () => async (dispatch, getState) => {
  let token = getState().auth.token
  let headers = { 'Content-Type': 'application/json' }
  if (token) {
    headers['Authorization'] = `Token ${token}`
    try {
        let response = await axios.get(
            `${SUBSCRIPTION_BASE_URL}/add_subscriber/`,
            { headers },
        )
        if (response.status === 200) {
          dispatch({ type: GET_SUBSCRIBER, data: response.data.data })
        }
    }
    catch (error) {
        throw (error)
    }
  }
}

export const addSubscribers = (data) => async (dispatch, getState) => {
  let token = getState().auth.token
  let headers = { 'Content-Type': 'application/json' }
  if (token) {
    headers['Authorization'] = `Token ${token}`
    try {
        let response = await axios.post(
            `${SUBSCRIPTION_BASE_URL}/add_subscriber/`,
            data,
            { headers },
        )
        if (response.status === 200 || response.status === 201) {
          dispatch(fetchSubscribers())
        }
    }
    catch (error) {
        throw (error)
    }
  }
}

export const activateSubscriber = (id, data) => async (dispatch, getState) => {
  let token = getState().auth.token
  let headers = { 'Content-Type': 'application/json' }
  if (token) {
    headers['Authorization'] = `Token ${token}`
    try {
        let response = await axios.put(
            `${SUBSCRIPTION_BASE_URL}/subscriber_details_api/${id}`,
            data,
            { headers },
        )
        if (response.status === 200 || response.status === 201) {
          dispatch(fetchSubscribers())
        }
    }
    catch (error) {
        throw (error)
    }
  }
}

export const deleteSubscriber = (id) => async (dispatch, getState) => {
  let token = getState().auth.token
  let headers = { 'Content-Type': 'application/json' }
  if (token) {
    headers['Authorization'] = `Token ${token}`
    try {
        let response = await axios.delete(
            `${SUBSCRIPTION_BASE_URL}/subscriber_details_api/${id}`,
            { headers },
        )
        if (response.status === 200 || response.status === 201) {
          dispatch(fetchSubscribers())
        }
    }
    catch (error) {
        throw (error)
    }
  }
}

export const subsChoiceSubscriber = () => async (dispatch, getState) => {
  let token = getState().auth.token
  let headers = { 'Content-Type': 'application/json' }
  if (token) {
    headers['Authorization'] = `Token ${token}`
    try {
        let response = await axios.get(
            `${SUBSCRIPTION_BASE_URL}/subs_choices_api/`,
            { headers },
        )
        if (response.status === 200) {
          dispatch({ type: GET_SUBSCHOICE, data: response.data })
        }
    }
    catch (error) {
        throw (error)
    }
  }
}

export const editCheckBoxSubscription = (checkboxData) => async (dispatch, getState) => {
  let token = getState().auth.token;
  let headers = { "Content-Type": "application/json" };

  if (token) {
    headers["Authorization"] = `Token ${token}`;
    try {
      const response = await axios.post(
        `${SUBSCRIPTION_BASE_URL}/edit_subscription/`,
        checkboxData,
        { headers }
      );

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: EDIT_SUBSCRIPTIONS_SUCCESS,
          payload: checkboxData,
        });
      }

      return response;
    } catch (error) {
      console.error("Edit Subscriptions Error:", error);
      throw error;
    }
  }
};

export const fetchCheckBoxSubscriptions = () => async (dispatch, getState) => {
  let token = getState().auth.token
  let headers = { 'Content-Type': 'application/json' }
  console.log("--- 1. fetchSubscriptions Action Initiated ---");
  if (token) {
    headers['Authorization'] = `Token ${token}`
    console.log("--- 2. Token Found, attempting API call ---");
    try {
        let response = await axios.get(
            `${SUBSCRIPTION_BASE_URL}/add_check/`,
            { headers },
        )
        console.log("Subscription Data from API:", response.data);
        const payload = response.data && response.data.data ? response.data.data : response.data;
        if (response.status === 200) {
          dispatch({ type: GET_SUBSCRIPTION_CHECKBOX, data: payload })
        }
        return response;
    }
    catch (error) {
        throw (error)
    }
  }
}
